module.exports = __webpack_public_path__ + "static/media/right_active.9ab42dce.png";